var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('contact-detail',{attrs:{"row-data":_vm.profile(),"prefix":"User Profile","parent-managed":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }